<mat-nav-list>
    <a href="/" mat-list-item *ngFor="let option of data" (click)="optionSelected($event, option)">
        <span mat-line>{{option.title}}</span>
        <span *ngIf="option.subtitle" mat-line class="fs-0-8 text-muted">{{option.subtitle}}</span>
    </a>
</mat-nav-list>